module.exports = __webpack_public_path__ + "static/img/video-loading.65bd7d2.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video-loading.gif
// module id = fYg7
// module chunks = 199